module.exports = __webpack_public_path__ + "static/colorpreviews-a9337da3f5dc426fec6cd117707b5b6d.png";